import VueRouter from 'vue-router';

// attributes:
// name used as window title
// icon (my custom attr) used as icon in the sidenav. value is material icon name
const routes = [{
    path: '/',
    name: 'Home',
    component: require('./content/home-page.vue').default,
    icon: 'home',
    inmenu: true
  },
  // {path: '/projects', name: 'Projects', component: require('./content/projects-page.vue').default, icon: 'web',inmenu: true},
  // {path: '/projects/:proj', name: 'Projects', component: require('./content/projects-page.vue').default, icon: 'web',inmenu: false},
  {
    path: '/projects',
    name: 'Projects',
    component: require('./content/projects-page.vue').default,
    children: [{
      path: ":proj",
      name: 'Projects' /* warning: duplicate routes */
      // component: require('./content/projects-page.vue').default
    }],
    icon: 'web',
    inmenu: true
  },

  {
    path: '/latest',
    name: 'Current project',
    component: require('./content/latest-page.vue').default,
    icon: 'build',
    inmenu: true
  },
  {
    path: '/contact',
    name: 'Contact',
    component: require('./content/contact-page.vue').default,
    icon: 'face',
    inmenu: true
  },
  {
    path: '/imprint',
    name: 'Imprint',
    component: require('./content/imprint-page.vue').default,
    icon: 'info_outline',
    inmenu: true
  },
  {
    path: '/desktop',
    name: ' ',
    component: require('./partials/Desktop.vue').default,
    inmenu: false
  },
  {
    path: '*',
    name: 'Error',
    component: require('./content/error-page.vue').default,
    inmenu: false
  },

];

const router = new VueRouter({
  mode: 'history',
  //base: process.env.NODE_ENV === 'production' ? '/about' : '',
  routes
});

export default router;



// WEBPACK FOOTER //
// ./src/router.js